module.exports = __webpack_public_path__ + "img/wificredentials.2cabe174.png";